import { render, staticRenderFns } from "./🍣.vue?vue&type=template&id=33dfe896&scoped=true&lang=pug&"
import script from "./🍣.vue?vue&type=script&lang=ts&"
export * from "./🍣.vue?vue&type=script&lang=ts&"
import style0 from "./🍣.vue?vue&type=style&index=0&id=33dfe896&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dfe896",
  null
  
)

component.options.__file = "🍣.vue"
export default component.exports